import { useState, useEffect } from "react";
import { Loader2 } from "lucide-react";

interface ThrottleOverlayProps {
  retryAfter: number;
  startedAt: number;
}

export function ThrottleOverlay({ retryAfter, startedAt }: ThrottleOverlayProps) {
  const [secondsLeft, setSecondsLeft] = useState(() => {
    const elapsed = Math.floor((Date.now() - startedAt) / 1000);
    return Math.max(0, retryAfter - elapsed);
  });

  useEffect(() => {
    const timer = setInterval(() => {
      const elapsed = Math.floor((Date.now() - startedAt) / 1000);
      setSecondsLeft(Math.max(0, retryAfter - elapsed));
    }, 1000);

    return () => clearInterval(timer);
  }, [retryAfter, startedAt]);

  return (
    <div className="absolute inset-0 bg-amber-50/95 border border-amber-200 rounded-xl flex items-center justify-center z-10">
      <div className="flex items-center gap-3">
        <Loader2 className="w-5 h-5 animate-spin text-amber-600" />
        <div className="flex flex-col">
          <span className="text-sm font-medium text-amber-800">
            Serveur temporairement surcharge
          </span>
          <span className="text-xs text-amber-600">
            {secondsLeft > 0
              ? `Reprise dans ${secondsLeft}s...`
              : "Vous pouvez redémarrer"}
          </span>
        </div>
      </div>
    </div>
  );
}
